import Vuex from 'vuex'

Vue.use(Vuex)


import {createContentfulClient} from "@/api/ContentfulClient";
import Vue from "vue";

const client = createContentfulClient();


export default new Vuex.Store({
    state: {
        config: {
            tidspunkt: '',
            tilmeldingsfrist: '',
            status: '',
            signup: false,
            preSignup: false,
            signupUrl: '',
            facebookEventUrl: ''
        }
    },
    mutations: {
    },
    actions: {
        async loadConfig() {
            this.error = this.post = null;
            this.loading = true;
            const entries = await client.getEntries({
                'content_type': 'configuration',
                'fields.slug': 'rd-config',
                'include': 3
            });
            if (entries.total >= 1) {
                const fields = entries.items[0].fields
                this.state.config = {...this.state.config, ...fields}
            }

        }
    }
})
